import { useRouter } from 'next/router';
import { Range, getTrackBackground } from 'react-range';
import { useEffect, useState } from 'react';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { useTranslation } from 'next-i18next';

interface AffordabilityRangeProps {
  stepTitle: any;
  filterType: SearchFiltersTypes;
  rangeStep: number;
  rangeMin: number;
  rangeMax: number;
  setDownPayment?: any;
  setInstallment?: any;
  isKeyboardOpen?: any;
  setIsKeyboardOpen: any;
}

const AffordabilityRange: React.FC<AffordabilityRangeProps> = ({
  stepTitle,
  filterType,
  rangeStep,
  rangeMin,
  rangeMax,
  setDownPayment,
  setInstallment,
  isKeyboardOpen,
  setIsKeyboardOpen
}) => {
  const { t } = useTranslation('search');
  const { locale } = useRouter();
  const [values, setValues] = useState([rangeMin]);

  const [prevViewportHeight, setPrevViewportHeight] = useState(
    window.visualViewport?.height || window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const currentViewportHeight =
        window.visualViewport?.height || window.innerHeight;

      if (currentViewportHeight < prevViewportHeight) {
        setIsKeyboardOpen(true);
      }

      if (currentViewportHeight > prevViewportHeight) {
        setIsKeyboardOpen(false);
      }

      setPrevViewportHeight(currentViewportHeight);
    };

    window.visualViewport?.addEventListener('resize', handleResize);

    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize);
    };
  }, [prevViewportHeight]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setValues([Math.max(values[0], rangeMin)]);
    }, 2000);

    return () => {
      clearTimeout(handler);
    };
  }, [values]);

  useEffect(() => {
    setValues([rangeMin]);
  }, [filterType]);

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = Number(e.target.value.replace(/,/g, ''));
    newValue = Math.min(newValue, rangeMax);
    if (!isNaN(newValue)) {
      setValues([newValue]);
      if (filterType === 'down_payment') {
        setDownPayment(Math.max(newValue, rangeMin));
      } else {
        setInstallment(Math.max(newValue, rangeMin));
      }
    }
  };

  const handleRangeChange = (values: number[]) => {
    setValues(values);
    if (filterType === 'down_payment') {
      setDownPayment(values[0]);
    } else {
      setInstallment(values[0]);
    }
  };

  return (
    <>
      <div className="step-question">{stepTitle}</div>
      <div className="slider-text">{t('slider_text')}</div>
      <div className="range-bar">
        <Range
          values={values}
          step={rangeStep}
          min={Math.min(values[0], rangeMin)}
          max={rangeMax}
          onChange={handleRangeChange}
          rtl={locale === 'ar'}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '5px',
                width: '100%',
                background: getTrackBackground({
                  values,
                  colors: ['#E8F4FF', '#E8F4FF'],
                  min: rangeMin,
                  max: rangeMax
                })
              }}
              className="range-bar-bg"
            >
              {children}
            </div>
          )}
          renderThumb={({ props: { key, ...rest } }) => (
            <div key={key} {...rest}>
              <div />
            </div>
          )}
        />
      </div>

      <div className={`input-container ${isKeyboardOpen && 'open-input'}`}>
        <input
          type="text"
          value={`${values[0] === 0 ? '' : values[0].toLocaleString()}`}
          onChange={handleValueChange}
        />
        <span className="currency">{t('EGP')}</span>
      </div>
    </>
  );
};

export default AffordabilityRange;
